/**
 * Concentric brand mark: nested rings evoking the "concentric" identity, paired with
 * the wordmark. A neutral, original geometric mark rather than a lifted asset — drop
 * a real logo in /public and swap the <Mark> if the exact brand file is preferred.
 */
export function Mark({ size = 28 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <circle cx="24" cy="24" r="21" stroke="currentColor" strokeOpacity="0.25" strokeWidth="2" />
      <circle cx="24" cy="24" r="14.5" stroke="currentColor" strokeOpacity="0.55" strokeWidth="2" />
      <circle cx="24" cy="24" r="8" stroke="currentColor" strokeWidth="2" />
      <circle cx="24" cy="24" r="2.6" fill="currentColor" />
    </svg>
  );
}

export default function Logo({
  size = 28,
  subtitle,
  className = '',
}: {
  size?: number;
  subtitle?: string;
  className?: string;
}) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <span className="text-accent">
        <Mark size={size} />
      </span>
      <div className="leading-tight">
        <div className="text-[15px] font-semibold tracking-tight text-ink">
          Concentric
          <span className="ml-1.5 font-light text-ink/45">Screening</span>
        </div>
        {subtitle ? <div className="text-[11px] uppercase tracking-widest text-ink/35">{subtitle}</div> : null}
      </div>
    </div>
  );
}
